import { render, staticRenderFns } from "./alarmDialog.vue?vue&type=template&id=32530f16&"
import script from "./alarmDialog.vue?vue&type=script&lang=js&"
export * from "./alarmDialog.vue?vue&type=script&lang=js&"
import style0 from "@STYLE/pages/video/alarm_style.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports